var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("courseware-default-container", {
    attrs: {
      container: _vm.container,
      containerClass: "cw-container-list",
      canEdit: _vm.canEdit,
      isTeacher: _vm.isTeacher
    },
    on: {
      storeContainer: _vm.storeContainer,
      sortBlocks: _vm.enableSort
    },
    scopedSlots: _vm._u([
      {
        key: "containerContent",
        fn: function fn() {
          return [
            !_vm.sortMode
              ? _c(
                  "ul",
                  {
                    staticClass: "cw-container-list-block-list"
                  },
                  [
                    _vm._l(_vm.blocks, function(block) {
                      return _c(
                        "li",
                        {
                          key: block.id,
                          staticClass: "cw-block-item"
                        },
                        [
                          _c(_vm.component(block), {
                            tag: "component",
                            attrs: {
                              block: block,
                              canEdit: _vm.canEdit,
                              isTeacher: _vm.isTeacher
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.showEditMode && _vm.canEdit && _vm.canAddElements
                      ? _c(
                          "li",
                          [
                            _c("courseware-block-adder-area", {
                              attrs: {
                                container: _vm.container,
                                section: 0
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sortMode && _vm.canEdit
              ? _c(
                  "draggable",
                  _vm._b(
                    {
                      staticClass:
                        "cw-container-list-block-list cw-container-list-sort-mode",
                      attrs: {
                        tag: "ul",
                        handle: ".cw-sortable-handle"
                      },
                      on: {
                        start: function start($event) {
                          _vm.isDragging = true
                        },
                        end: function end($event) {
                          _vm.isDragging = false
                        }
                      },
                      model: {
                        value: _vm.blockList,
                        callback: function callback($$v) {
                          _vm.blockList = $$v
                        },
                        expression: "blockList"
                      }
                    },
                    "draggable",
                    _vm.dragOptions,
                    false
                  ),
                  [
                    _c(
                      "transition-group",
                      {
                        attrs: {
                          type: "transition",
                          name: "flip-blocks"
                        }
                      },
                      _vm._l(_vm.blockList, function(block) {
                        return _c(
                          "li",
                          {
                            key: block.id,
                            staticClass: "cw-block-item cw-block-item-sortable"
                          },
                          [
                            _c(_vm.component(block), {
                              tag: "component",
                              attrs: {
                                block: block,
                                canEdit: _vm.canEdit,
                                isTeacher: _vm.isTeacher
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sortMode && _vm.canEdit
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "button accept",
                      on: {
                        click: _vm.storeSort
                      }
                    },
                    [_c("translate", [_vm._v("Sortierung speichern")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button cancel",
                      on: {
                        click: _vm.resetSort
                      }
                    },
                    [_c("translate", [_vm._v("Sortieren abbrechen")])],
                    1
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }